module.exports = __webpack_public_path__ + "img/round-white-tick.1371650f.svg";